"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatus = exports.getType = exports.removeLast = void 0;
function removeLast(actions, comparator) {
    // TODO: accomplish the same in one loop
    const last = actions.filter(comparator).pop();
    return actions.filter(action => action !== last);
}
exports.removeLast = removeLast;
const ACTION_TYPE_REGEX = /\[(Request|Failure|Success|Clear)\]\s(.+)/;
const getType = (action) => {
    const match = ACTION_TYPE_REGEX.exec(action.type);
    if (match && match.length > 2) {
        return match[2];
    }
    return '';
};
exports.getType = getType;
const getStatus = (action) => {
    const match = ACTION_TYPE_REGEX.exec(action.type);
    if (match && match.length > 2) {
        return match[1].toUpperCase();
    }
    return '';
};
exports.getStatus = getStatus;
//# sourceMappingURL=utils.js.map